import { Checkout } from '@vp/common';

type HiveSubscribeDetails = {
  email?: string;
  didOptIn?: boolean;
  phoneNumber?: string;
  didSmsOptIn?: boolean;

  firstName?: string;
  lastName?: string;

  zipCode?: string;
  country?: string;
  city?: string;
  state?: string;
  mailingAddress?: string;
};

export const useHive = (brandId: string) => {
  if (typeof window === 'undefined') {
    throw new Error('window must be defined');
  }

  (function (h, i, v, e, s, d, k) {
    h.HiveSDKObject = s;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    h[s] = h[s] || function () {
      // eslint-disable-next-line prefer-rest-params
      (h[s].q = h[s].q || []).push(arguments);
    }, d = i.createElement(v), k = i.getElementsByTagName(v)[0];
    d.async = 1;
    d.id = s;
    d.src = e + '?r=' + parseInt(new Date() / 60000);
    k.parentNode.insertBefore(d, k);
  })(window, document, 'script', 'https://cdn-prod.hive.co/static/js/sdk-loader.js', 'HIVE_SDK');

  HIVE_SDK('init', brandId);

  const subscribeCustomerToHive = (details: HiveSubscribeDetails) => {
    HIVE_SDK('emailSignup', details);
  };

  const confirmOrder = (orderSummary: Checkout.OrderSummary.OrderSummary, eventUrl: string) => {
    const artists = orderSummary.event.artists?.map(artist => artist).join(', ');

    // TODO: eventUrl is temporary, and should be obtained from event object
    HIVE_SDK(
      'ticketingOrder',
      'create',
      {
        id: orderSummary.fingerprint.slice(-10),
        status: 'completed',
        total_paid: orderSummary.breakdown.orderTotal,

        event: {
          id: orderSummary.event.id,
          name: orderSummary.event.name,
          description: orderSummary.event.description,
          start_time: orderSummary.event.startTime,
          end_time: orderSummary.event.endTime,
          url: eventUrl,
          image_url: orderSummary.event.images?.[0]?.variants?.[0]?.src,

          artist_names: artists,
          // artist_names: formatHiveParam($('#hive_event_artists')),
          // tag_names: formatHiveParam($('#hive_event_tags')),
          // genre_names: formatHiveParam($('#hive_event_tags')),
        },

        venue: {
          name: orderSummary.event.venue?.name,
          city: orderSummary.event.venue?.city,
          state: orderSummary.event.venue?.state,
          country: orderSummary.event.venue?.country,
        },
      },
    );
  };

  return {
    subscribeCustomerToHive,
    confirmOrder,
  };
};
